import { Component } from '@angular/core';

@Component({
    selector: 'app-sidebar-header',
    templateUrl: './app-sidebar-header.component.html',
    standalone: false
})
export class AppSidebarHeaderComponent { }
